import { FraseScreen } from "app/screens/residents/show/FraseScreen";

export default function FrasePage() {
  return <FraseScreen />;
}
